function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  strokeMiterlimit: 8
}, React.createElement("rect", {
  className: "icon-tertiary",
  x: 9.495,
  y: 18.555,
  width: 22.957,
  height: 14.006,
  fill: "#fff",
  stroke: "#002060"
}), React.createElement("g", {
  className: "icon-tertiary"
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m12.542 29.36 5.5788-2.1344 5.658 1.6008 5.4223-4.2686",
  fill: "none",
  stroke: "#002060"
}), React.createElement("g", {
  className: "icon-secondary",
  transform: "matrix(.20316 0 0 .20009 1.6733 13.052)",
  fill: "#adb9ca",
  fillRule: "evenodd",
  strokeWidth: 4.9598
}, React.createElement("path", {
  d: "m104.5 79c0-1.933 1.57-3.5 3.5-3.5s3.5 1.567 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.567-3.5-3.5z"
}), React.createElement("path", {
  d: "m49.5 80.903c0-1.8792 1.57-3.4029 3.5-3.4029s3.5 1.5236 3.5 3.4029-1.57 3.4029-3.5 3.4029-3.5-1.5236-3.5-3.4029z"
}), React.createElement("path", {
  d: "m76.5 70.5c0-2.209 1.79-4 4-4s4 1.791 4 4-1.79 4-4 4-4-1.791-4-4z"
})), React.createElement("path", {
  className: "icon-primary",
  d: "m28.389 24.457c0-0.38678 0.30937-0.70031 0.69135-0.70031 0.38197 0 0.69135 0.31354 0.69135 0.70031 0 0.38677-0.30937 0.70031-0.69135 0.70031-0.38198 0-0.69135-0.31354-0.69135-0.70031z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("g", {
  className: "icon-tertiary",
  transform: "matrix(.20316 0 0 .20009 -.56955 3.3565)",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 4.9598
}, React.createElement("path", {
  d: "m115.54 127.46c0-1.933 1.57-3.5 3.5-3.5s3.5 1.567 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.567-3.5-3.5z"
}), React.createElement("path", {
  d: "m60.54 129.36c0-1.8792 1.57-3.4029 3.5-3.4029s3.5 1.5236 3.5 3.4029c0 1.8792-1.57 3.4029-3.5 3.4029s-3.5-1.5236-3.5-3.4029z"
}), React.createElement("path", {
  d: "m87.54 118.96c0-2.209 1.79-4 4-4s4 1.791 4 4-1.79 4-4 4-4-1.791-4-4z"
}), React.createElement("path", {
  d: "m142.54 105.46c0-1.933 1.5228-3.5 3.4029-3.5s3.4029 1.567 3.4029 3.5-1.5228 3.5-3.4029 3.5-3.4029-1.567-3.4029-3.5z"
}))));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  strokeMiterlimit: 10
}, React.createElement("g", null, React.createElement("path", {
  className: "icon-tertiary",
  d: "m9.9392 12.113c0-1.3563 1.1129-2.4558 2.4863-2.4558h11.603c1.3734 0 2.4863 1.0995 2.4863 2.4558v9.8234c0 1.3563-1.1129 2.4558-2.4863 2.4558h-11.603c-1.3734 0-2.4863-1.0995-2.4863-2.4558z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m12.421 9.6568h11.612c1.371 0 2.4816 1.0731 2.4816 2.3971v2.7484h-16.575v-2.7484c0-1.3241 1.1105-2.3971 2.4816-2.3971z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m12.421 9.6568h11.612c1.371 0 2.4816 1.0731 2.4816 2.3971v2.7484h-16.575v-2.7484c0-1.3241 1.1105-2.3971 2.4816-2.3971z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), React.createElement("path", {
  className: "icon-tertiary",
  d: "m6.5606 10.029c0-1.368 1.1357-2.477 2.5371-2.477h11.84c1.4015 0 2.5371 1.109 2.5371 2.477v9.9081c0 1.368-1.1357 2.477-2.5371 2.477h-11.84c-1.4015 0-2.5371-1.109-2.5371-2.477z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m9.1055 7.5519h11.612c1.371 0 2.4815 1.122 2.4815 2.5061v2.8733h-16.575v-2.8733c0-1.3842 1.1105-2.5061 2.4815-2.5061z",
  fill: "#ecaec6",
  fillRule: "evenodd"
})), React.createElement("g", {
  className: "icon-secondary",
  transform: "translate(-4.9737 -9.1684)",
  fill: "#adb9ca",
  strokeMiterlimit: 10
}, React.createElement("rect", {
  x: 14.425,
  y: 23.632,
  width: 2.1311,
  height: 2.105
}), React.createElement("rect", {
  x: 14.531,
  y: 27.522,
  width: 2.1311,
  height: 2.105
})), React.createElement("path", {
  className: "icon-tertiary",
  d: "m9.5545 9.763c0-0.18774 0.14575-0.34001 0.32307-0.34001h10.285c0.17732 0 0.32307 0.15228 0.32307 0.34001v1.3606c0 0.18774-0.14575 0.34001-0.32307 0.34001h-10.285c-0.17732 0-0.32307-0.15228-0.32307-0.34001z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m9.1105 7.5519h11.835c1.3973 0 2.5291 1.1352 2.5291 2.5357v2.9073h-16.893v-2.9073c0-1.4005 1.1318-2.5357 2.5291-2.5357z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(-4.9737 -9.1684)",
  stroke: "#002060"
}, React.createElement("path", {
  d: "m19.009 24.653h6.9522",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "m19.073 28.649h6.9098",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("rect", {
  x: 14.51,
  y: 23.674,
  width: 2.0463,
  height: 1.9991,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("rect", {
  x: 14.531,
  y: 27.67,
  width: 1.9828,
  height: 1.9779,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
})));

var SvgMenuPulseTrend = function SvgMenuPulseTrend(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuPulseTrend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-pulse-trend.e1174436.svg";
export { ForwardRef as ReactComponent };